import type { LimitCardFilter } from "@src/api/stock/limitCards";
import {
    defineFilterConfig,
    filterDateIntervalFromNotAfterTo,
    filterDateIntervalToNotBeforeFrom,
    filterFieldAdapters,
} from "@src/components/business-form";

/** Значения filter-формы списка ЛК УП. */
export interface WsLimitCardsFilterFormValues {
    num: string;
    senderCode: number | null;
    receiverCode: number | null;
    startPeriodFrom: string | null;
    finishPeriodTo: string | null;
    stockobjDescription: string;
}

export const wsLimitCardsFilterFormConfig = defineFilterConfig<WsLimitCardsFilterFormValues, LimitCardFilter>({
    fields: {
        num: {
            type: "string",
            label: "№ лимитной карты",
            map: filterFieldAdapters.ompSearchString("Num"),
        },
        senderCode: {
            type: "number",
            nullable: true,
            label: "Отправитель",
            map: filterFieldAdapters.singleCodeArray("SenderCodes"),
        },
        receiverCode: {
            type: "number",
            nullable: true,
            label: "Получатель",
            map: filterFieldAdapters.singleCodeArray("ReceiverCodes"),
        },
        startPeriodFrom: {
            type: "date",
            nullable: true,
            label: "Период действия (с)",
            map: filterFieldAdapters.ompFilterDateBound("StartDate", "from"),
            validation: {
                validate: (value, formValues) => filterDateIntervalFromNotAfterTo(value, formValues.finishPeriodTo),
                deps: ["finishPeriodTo"],
            },
        },
        finishPeriodTo: {
            type: "date",
            nullable: true,
            label: "Период действия (по)",
            map: filterFieldAdapters.ompFilterDateBound("FinishDate", "to"),
            validation: {
                validate: (value, formValues) => filterDateIntervalToNotBeforeFrom(value, formValues.startPeriodFrom),
                deps: ["startPeriodFrom"],
            },
        },
        stockobjDescription: {
            type: "string",
            label: "Номенклатура ТМЦ",
            map: filterFieldAdapters.ompSearchString("StockobjDescription"),
        },
    },
});
